import { P as Pagination } from './pagination-BYB1eQGc.js';
import { S as Swiper } from './index-1rH35xIi.js';
import './classes-to-selector-B0Ehowsi.js';
import './create-element-if-not-defined-CpMCDYSa.js';
import './swiper-core-ClzX336E.js';
import './a11y-BJABkpRI.js';

class USPsSlider extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
      a11y: {
        slideRole: 'listitem',
      },
    });
  }
}

customElements.define('usps-slider', USPsSlider);
